import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';
import { default as DjangoRestFramework } from '@burnsred/entity-duck-namespace-drf';

import { duckAppName } from '@/constants';

class BusinessAreaEntity extends Entity {
  static paginated = false;

  static paths = {
    apiBase: '/applications/v1/business_area/',
  };

  static fields: EntityFields<BusinessAreaEntityFields> = {
    uuid: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
  };

  static dataToRecord(data: Partial<BusinessAreaEntityFields>) {
    return super.dataToRecord(data) as BusinessAreaEntityRecord;
  }

  static toString(record: BusinessAreaEntityRecord | null | undefined) {
    return record?.get('name') ?? '';
  }
}

export type BusinessAreaEntityFields = {
  uuid: string;
  name: string;
};

export type BusinessAreaEntityRecord = EntityRecord<BusinessAreaEntityFields>;

BusinessAreaEntity.duck = new DjangoRestFramework({
  app: duckAppName,
  entity: BusinessAreaEntity,
  name: 'BusinessAreaEntity',
});

export default BusinessAreaEntity;
